/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAdminUserWalletPageListRespVo } from './GetAdminUserWalletPageListRespVo';
import {
    GetAdminUserWalletPageListRespVoFromJSON,
    GetAdminUserWalletPageListRespVoFromJSONTyped,
    GetAdminUserWalletPageListRespVoToJSON,
    GetAdminUserWalletPageListRespVoToJSONTyped,
} from './GetAdminUserWalletPageListRespVo';

/**
 * 
 * @export
 * @interface PageDataGetAdminUserWalletPageListRespVo
 */
export interface PageDataGetAdminUserWalletPageListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetAdminUserWalletPageListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetAdminUserWalletPageListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetAdminUserWalletPageListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetAdminUserWalletPageListRespVo>}
     * @memberof PageDataGetAdminUserWalletPageListRespVo
     */
    records?: Array<GetAdminUserWalletPageListRespVo>;
}

/**
 * Check if a given object implements the PageDataGetAdminUserWalletPageListRespVo interface.
 */
export function instanceOfPageDataGetAdminUserWalletPageListRespVo(value: object): value is PageDataGetAdminUserWalletPageListRespVo {
    return true;
}

export function PageDataGetAdminUserWalletPageListRespVoFromJSON(json: any): PageDataGetAdminUserWalletPageListRespVo {
    return PageDataGetAdminUserWalletPageListRespVoFromJSONTyped(json, false);
}

export function PageDataGetAdminUserWalletPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetAdminUserWalletPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetAdminUserWalletPageListRespVoFromJSON)),
    };
}

export function PageDataGetAdminUserWalletPageListRespVoToJSON(json: any): PageDataGetAdminUserWalletPageListRespVo {
    return PageDataGetAdminUserWalletPageListRespVoToJSONTyped(json, false);
}

export function PageDataGetAdminUserWalletPageListRespVoToJSONTyped(value?: PageDataGetAdminUserWalletPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetAdminUserWalletPageListRespVoToJSON)),
    };
}

